export class LoanTransaction {
  /**
   * @param {number} id
   * @param {number} profileId
   * @param {string} trxType
   * @param {number} amount
   * @param {string} concept
   * @param {number} status
   * @param {string} createdAt
   * @param {string} trxConfirmationDate
   */
  constructor(
    id,
    profileId,
    trxType,
    amount,
    concept,
    status,
    createdAt,
    trxConfirmationDate
  ) {
    this.id = id;
    this.profileId = profileId;
    this.trxType = trxType;
    this.amount = amount;
    this.concept = concept;
    this.status = status;
    this.createdAt = createdAt;
    this.trxConfirmationDate = trxConfirmationDate;
  }
}
